import Model from './model';
import isM3 from './isformat';

export default {
  Model,
  isM3,
};
